"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");

var NChangedProdThreshold_1 = require("./NChangedProdThreshold");
/**
 * @author Tomas Leity
 */


var NChangedProdThresholdDTO =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NChangedProdThresholdDTO, _NotificationDoc_1$No);

  /**
   * @param products
   */
  function NChangedProdThresholdDTO(products) {
    var _this;

    _classCallCheck(this, NChangedProdThresholdDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedProdThresholdDTO).call(this));
    _this.products = products;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NChangedProdThresholdDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NChangedProdThresholdDTO(mat.products);
    }
  }]);

  return NChangedProdThresholdDTO;
}(NotificationDoc_1.NotificationDoc);

exports.NChangedProdThresholdDTO = NChangedProdThresholdDTO;

NChangedProdThresholdDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NChangedProdThresholdDTO.name);
  return {
    products: builder.listOf(builder.obj('products', NChangedProdThreshold_1.NChangedProdThreshold.schema, function (mat) {
      return NChangedProdThreshold_1.NChangedProdThreshold.fromDataDict(mat);
    }))
  };
}();